import { Sparkles } from "lucide-react";

const confettiPieces = Array.from({ length: 26 }, (_, index) => ({
  id: index,
  left: `${(index * 3.7) % 96}%`,
  delay: `${(index % 7) * 0.12}s`,
  duration: `${2.4 + (index % 5) * 0.22}s`,
  rotation: `${(index * 23) % 360}deg`,
  color: ["#D4AF37", "#FFF3D0", "#E7D4A3", "#F8F3EA"][index % 4],
}));

export const FoundingMemberCelebration = ({ onClose, open, user }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-[#16120b]/42 px-4 backdrop-blur-sm" data-testid="founding-member-celebration-overlay">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {confettiPieces.map((piece) => (
          <span
            className="absolute top-[-10%] h-5 w-3 rounded-full opacity-90"
            key={piece.id}
            style={{
              left: piece.left,
              background: piece.color,
              transform: `rotate(${piece.rotation})`,
              animation: `founding-confetti-fall ${piece.duration} linear ${piece.delay} forwards`,
            }}
          />
        ))}
      </div>

      <div className="relative w-full max-w-xl rounded-[30px] border border-[#D4AF37]/24 bg-[linear-gradient(160deg,#171717_0%,#1F1F1F_56%,#26221E_100%)] p-8 text-center text-[#F6F1E9] shadow-[0_30px_90px_rgba(22,18,11,0.3)]" data-testid="founding-member-celebration-modal">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#2A2724] text-[#D4AF37]">
          <Sparkles className="h-7 w-7" />
        </div>
        <p className="mt-5 text-xs font-bold uppercase tracking-[0.24em] text-[#D4AF37]">Welcome to the Founding 18</p>
        <h2 className="mt-4 font-[Cormorant_Garamond,serif] text-4xl font-bold leading-none text-[#F6F1E9]" data-testid="founding-member-celebration-heading">
          {user?.name}, your boutique portal is now live.
        </h2>
        <p className="mt-4 text-sm leading-8 text-[#B8B0A5]" data-testid="founding-member-celebration-copy">
          Your public route is open, your listings are now eligible in the global marketplace, and your Founding 18 dashboard has taken over from the private showroom.
        </p>
        <button className="gold-button mt-6" data-testid="founding-member-celebration-close-button" onClick={onClose} type="button">
          Enter Founding 18 Dashboard
        </button>
      </div>

      <style>{`
        @keyframes founding-confetti-fall {
          0% { transform: translate3d(0, 0, 0) rotate(0deg); opacity: 0; }
          8% { opacity: 1; }
          100% { transform: translate3d(0, 115vh, 0) rotate(540deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
};